import { api, ApiError } from "@/api/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function useTags() {
  return useQuery<string[], ApiError>({
    queryKey: ["GET", "tags"],
    queryFn: api.tags.get,
  });
}

type ManageTagData = { episodeIds: string[]; tag: string };

export function useAddTag() {
  const queryClient = useQueryClient();
  return useMutation<object, ApiError, ManageTagData>({
    mutationKey: ["PATCH", "addTag"],
    mutationFn: (data) =>
      api.episodes.addTag.patch({ episodeIds: data.episodeIds, tag: data.tag }),
    onSuccess: (_, data) => {
      data.episodeIds.forEach((episodeId) => {
        queryClient.invalidateQueries({ queryKey: ["GET", "episodeDetails", episodeId] });
      });
      queryClient.invalidateQueries({ queryKey: ["GET", "episodes"] });
      queryClient.invalidateQueries({ queryKey: ["GET", "images"] });
      queryClient.invalidateQueries({ queryKey: ["GET", "masks"] });
    },
  });
}

export function useRemoveTag() {
  const queryClient = useQueryClient();

  return useMutation<object, ApiError, ManageTagData>({
    mutationKey: ["PATCH", "removeTag"],
    mutationFn: (data) =>
      api.episodes.removeTag.patch({ episodeIds: data.episodeIds, tag: data.tag }),
    onSuccess: (_, data) => {
      queryClient.invalidateQueries({ queryKey: ["GET", "episodes"] });
      queryClient.invalidateQueries({ queryKey: ["GET", "images"] });
      queryClient.invalidateQueries({ queryKey: ["GET", "masks"] });
      data.episodeIds.forEach((episodeId) => {
        queryClient.invalidateQueries({ queryKey: ["GET", "episodeDetails", episodeId] });
      });
    },
  });
}
